import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById("root"));
console.log = () => {};
console.error = () => {};
console.debug = () => {};
console.warn=()=>{};

// Global error handler for unhandled promise rejections (timeout errors, etc.)
window.addEventListener('unhandledrejection', (event) => {
  // Check if it's a timeout error that was already handled
  const error = event.reason;
  const isTimeoutError = error?.code === 'ECONNABORTED' || 
                        error?.message?.includes('timeout') || 
                        error?.message?.includes('Timeout');
  
  if (isTimeoutError) {
    // Timeout errors are already handled in callApi with user-friendly messages
    // Prevent React error overlay from showing for these handled errors
    event.preventDefault();
    return;
  }
  
  // For other unhandled rejections, log them but don't prevent
  // Let ErrorBoundary handle React-related errors
  console.error('Unhandled promise rejection:', error);
});

// Global error handler for runtime errors
window.addEventListener('error', (event) => {
  // Check if it's a timeout error
  const isTimeoutError = event.error?.code === 'ECONNABORTED' || 
                        event.error?.message?.includes('timeout') || 
                        event.error?.message?.includes('Timeout') ||
                        event.message?.includes('timeout') ||
                        event.message?.includes('Timeout');
  
  if (isTimeoutError) {
    // Prevent React error overlay for timeout errors (already handled)
    event.preventDefault();
    return;
  }
  
  // Log other errors for debugging (don't prevent - let ErrorBoundary handle)
  console.error('Global error:', event.error || event.message);
});

root.render(<App />);
